/**
 * Congresses module
 *
 * Module index file
 *
 * This file is used by theme to provide default functionality
 * to the module and to register all components.
 *
 * This file has to export setup function that will be called
 * automatically by import in the theme app.ts file.
 */

import { App } from 'vue';

import AdminAccommodations from '@src/Congresses/Pages/Accommodations/AdminAccommodations.vue';
import AdminSchedule from '@src/Congresses/Pages/Schedule/AdminSchedule.vue';
import AdminTickets from '@src/Congresses/Pages/Tickets/AdminTickets.vue';
import AdminCommittees from '@src/Congresses/Pages/Committees/AdminCommittees.vue';
import AdminCongressNews from '@src/Congresses/Pages/News/AdminCongressNews.vue';
import AdminCommitteeMembers from '@src/Congresses/Pages/CommitteeMembers/AdminCommitteeMembers.vue';
import LatestTicketOrdersBlock from '@src/Congresses/Pages/Blocks/LatestTicketOrdersBlock.vue';
import AdminStakeholderLogo from '@src/Congresses/Pages/Fields/AdminStakeholderLogo.vue';
import UpcomingCongressesBlock from '@src/Congresses/Pages/Blocks/UpcomingCongressesBlock.vue';
import CheckInBlock from '@src/Congresses/Pages/Blocks/CheckInBlock.vue';
import WalkInOrderBlock from '@src/Congresses/Pages/Blocks/WalkInOrderBlock.vue';

export const setup = (app: App<Element>): void => {
    app.component('LatestTicketOrdersBlock', LatestTicketOrdersBlock);
    app.component('UpcomingCongressesBlock', UpcomingCongressesBlock);
    app.component('WalkInOrderBlock', WalkInOrderBlock);
    app.component('CheckInBlock', CheckInBlock);
    app.component('AdminCongressSchedule', AdminSchedule);
    app.component('AdminAccommodations', AdminAccommodations);
    app.component('AdminCongressTickets', AdminTickets);
    app.component('AdminCommittees', AdminCommittees);
    app.component('AdminCommitteeMembers', AdminCommitteeMembers);
    app.component('AdminCongressNews', AdminCongressNews);
    app.component('AdminStakeholderLogo', AdminStakeholderLogo);
};
